import React from "react";
import Seo from "../components/Seo";
import Layout from "../layouts/sample";
import {Intro} from '../components/ambassadors/Intro';
import {Protocols} from '../components/ambassadors/Protocols';
import {Benefits} from '../components/ambassadors/Benefits';
import {Rewards} from '../components/ambassadors/Rewards';
import {graphql} from "gatsby";
import {Responsibilities} from "../components/ambassadors/Responsibilities";

const AmbassadorsPage = (props) => {
  const acf = props.data.page.template.ambassadorsPageACF || {};

  const translations = props?.data?.page?.translations || {}

  return (
    <Layout translations={translations}>
      <Intro data={acf.intro ||{}} />
      <Benefits data={acf.benefits || {}}/>
      <Responsibilities data={acf.responsibilities || {}}/>
      <Rewards data={acf.rewards || {}}/>
      <Protocols data={acf.protocols || {}}/>
    </Layout>
  );
};

export default AmbassadorsPage;
export const pageQuery = graphql`
  query ($lng: String!, $id: Int!) {
    locales: allLocale(
      filter: { language: { eq: $lng } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    page : wpPage(language: {slug: {eq: $lng}}, databaseId: { eq: $id }) {
      translations {
        slug
      }
      seo {
        metaDesc
        opengraphDescription
        opengraphTitle
        title
      }
      template {
        ... on WpTemplate_Ambassadors {
          ambassadorsPageACF {
            twitter{
              title
              link {
                title
                url
                target
              }
            }
            rewards {
              subtitle
              title
              number
              items {
                color
                text
                title
                label
              }
              link {
                target
                title
                url
              }
              column1
              column2
              column3
            }
            responsibilities {
              number
              subtitle
              text
              title
              items {
                color
                text
                title
                button {
                  title
                  url
                  target
                }
              }
            }
            protocols {
              number
              subtitle
              title
              items {
                text
                title
              }
            }
            intro {
              number
              suptext1
              text
              titlePart1
              titlePart2
              titlePart3
              link {
                title
                url
                target
              }
            }
            benefits {
              number
              subtitle
              title
              items {
                class
                color
                text
                title
                button {
                  target
                  title
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const Head = (props) => {
  const seo = props.data.page?.seo || {}
  return <Seo title={seo?.title} description={seo?.metaDesc} />;
}
